import React from "react";
import Spinner from "../library/Spinner";
import { css } from "glamor";

const container = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  width: "100vw",
});

export default function CreateMock({ mockTemplate }) {
  return (
    <div className={container}>
      {!mockTemplate && (
        <Spinner text="Carregando Simulado" wrapped />
      )}
    </div>
  );
}
